import {
  IData_Booking_Availability_DayOfWeek,
  IData_Booking_Availability,
  IData_Booking_Pricing,
  IData_Booking_General_Config,
  IData_Booking_State_Query,
  IData_Booking_State,
  IData_Booking_State_Any,
  IData_Booking_State_Cancelled,
  IData_Booking_State_Confirmed,
  IData_Booking_State_Invalid,
  IData_Booking_State_Completed,
  IData_Booking_State_Draft,
  IData_Booking_Settings_Mode_Active,
  IData_Booking_Settings_Mode_Historic,
} from '../types/schema/booking'

export const BOOKING_EMAIL_REPLACE_TEXT = 'BOOKING_DETAILS'

export const BOOKING_DEFAULT_PRODUCT_LENGTH = 180

export const BOOKING_SETTINGS_MODE_ACTIVE: IData_Booking_Settings_Mode_Active = 'active'
export const BOOKING_SETTINGS_MODE_HISTORIC: IData_Booking_Settings_Mode_Historic = 'historic'

export const BOOKING_PROJECT_NAME = 'firstthermal'
export const BOOKING_DEFAULT_USERNAME = 'org'

export const BOOKING_DAYS_OF_WEEK: IData_Booking_Availability_DayOfWeek[] = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
]

export const BOOKING_DAYS_OF_WEEK_BY_DATE: IData_Booking_Availability_DayOfWeek[] = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday', 
]

export const BOOKING_HOURS: number[] = [
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
]

export const BOOKING_MINS: number[] = [
  0,
  5,
  10,
  15,
  20,
  25,
  30,
  35,
  40,
  45,
  50,
  55,
]

export const BOOKING_DEFAULT_AVAILABILITY: IData_Booking_Availability = {
  daysOfWeek: [],
  dateSlots: [],
  timeSlots: [],
  activeDays: 0,
  holiday: false,
}

export const BOOKING_DEFAULT_PRICING: IData_Booking_Pricing = {
  products: [],
}

export const BOOKING_DEFAULT_GENERAL_CONFIG: IData_Booking_General_Config = {
  new_booking_email_template: '',
  updated_booking_email_template: '',
  cancelled_booking_email_template: '',
  admin_booking_email_template: '',
  coverage_outcodes: '',
  travel_time_before: 30,
  travel_time_after: 30,
  slot_interval: 30,
  buffer_zone: 3,
  cutoff_zone: 30,
  contact_email: '',
  contact_phone: '',
}

export const BOOKING_AUTO_TAG = 'booking'

export const BOOKING_STATE_ANY: IData_Booking_State_Any = 'any'
export const BOOKING_STATE_DRAFT: IData_Booking_State_Draft = 'draft'
export const BOOKING_STATE_CANCELLED: IData_Booking_State_Cancelled = 'cancelled'
export const BOOKING_STATE_CONFIRMED: IData_Booking_State_Confirmed = 'confirmed'
export const BOOKING_STATE_INVALID: IData_Booking_State_Invalid = 'invalid'
export const BOOKING_STATE_COMPLETED: IData_Booking_State_Completed = 'completed'

export const BOOKING_STATE_DEFAULT = BOOKING_STATE_ANY

export const BOOKING_STATE_TITLES: Record<IData_Booking_State_Query, string> = {
  [BOOKING_STATE_ANY]: 'Any',
  [BOOKING_STATE_DRAFT]: 'Draft',
  [BOOKING_STATE_CANCELLED]: 'Cancelled',
  [BOOKING_STATE_CONFIRMED]: 'Confirmed',
  [BOOKING_STATE_INVALID]: 'Invalid',
  [BOOKING_STATE_COMPLETED]: 'Completed',
}

export const BOOKING_STATE_OPTIONS: IData_Booking_State[] = [
  BOOKING_STATE_DRAFT,
  BOOKING_STATE_CANCELLED,
  BOOKING_STATE_CONFIRMED,
  BOOKING_STATE_INVALID,
  BOOKING_STATE_COMPLETED,
]

export const BOOKING_CRM_FIELDS = [
  'firstname',
  'surname',
  'email',
  'company',
  'phone_number',
  'address1',
  'address2',
  'city',
  'postcode',
  'country',
]

export const BOOKING_DEFAULT_CALENDAR_DAYS = 3
export const BOOKING_DEFAULT_CALENDAR_LENGTH = 120

export const BOOKING_FORM_NAMES = [
  'presurvey',
  'postsurvey',
  'monthfeedback',
  'yearfeedback',
]

export const BOOKING_ET_ROLE_NAME = 'heatview_surveyor'
export const BOOKING_REPORT_DEFAULT = 'perorg-monthly'